import React from "react";
import ReactDOM from "react-dom";
import { GlobalLoader } from "../components/GlobalLoader";

let isVisible = false;

export function showGlobalLoader() {
  if (isVisible) return;
  isVisible = true;
  render(true);
}

export function hideGlobalLoader() {
  if (!isVisible) return;
  isVisible = false;
  render(false);
}

function render(show) {
  const container = document.getElementById("global-loader-root");
  if (!container) return;

  ReactDOM.render(<GlobalLoader open={show} />, container);
}
